<template>
  <v-flex
    v-if="!loading"
  >
  <div>
    <v-container fill-height fluid>
    <v-row>
      <v-flex xs3 class="mr-2">
        <Search
          v-model="filters.search"
          :label="$t('SEARCH')"
          prepend-icon="search"
          :delay="500"
        />
      </v-flex>
      <v-spacer></v-spacer>
    </v-row>
    </v-container>
    <v-data-table
      v-model="schoolSelected"
      :single-select="false"
      show-select
      item-key="id"
      :headers="headers"
      :items="items"
      :server-items-length="totalItems"
      :no-data-text="$t('NO_DATA')"
      :no-results-text="$t('NO_DATA')"
      hide-default-footer
      :options.sync="pagination"
      :loading="loading"
      class="elevation-1"
    >
    </v-data-table>
    <div class="pt-2">{{$t('fields.total_items')}} {{ totalItems }}</div>
    <div class="text-xs-center pt-2">
      <Paginator
        :total-items="totalItems"
        :page.sync="pagination.page"
        :items-per-page.sync="pagination.itemsPerPage"
        @change="fetchTeachers"
      />
    </div>
  </div>
  </v-flex>
  <Loader v-else/>
</template>

<script>
  import { mapActions } from 'vuex';

  import { teachersService } from '../../../utils/services/teachers.service';
  import Search from '../../shared/Inputs/Search';
  import Loader from '../../shared/Loader';
  import Paginator from '../../shared/Paginator';

  export default {
    name: 'SchoolTeacherSelection',
    components: { Search, Loader, Paginator },
    props: {
      perPage: {
        type: Number,
        default: 5,
      },
      schoolIds: {
        type: Array,
        default: () => [],
      },
    },
    data() {
      return {
        loading: false,
        items: [],
        schoolSelected: [],
        totalItems: 0,
        pagination: {
          page: 1,
          itemsPerPage: this.perPage,
          sortDesc: [true],
          sortBy: ['surname'],
        },
        headers: [
          { text: this.$t('fields.name'), value: 'fulltext', sortable: false },
        ],
        filters: {
          search: null,
        },
      };
    },
    computed: {
      requestFilters() {
        const filters = {
          search: this.filters.search,
          schoolIds: this.schoolIds,
        };
        if (this.pagination.sortBy.length === 1 && this.pagination.sortDesc.length === 1) {
          const { sortBy, sortDesc } = this.pagination;
          filters.sortBy = sortBy;
          filters.sortDesc = sortDesc;
        }

        return filters;
      },
    },
    methods: {
      ...mapActions('confirm', ['showConfirm']),
      ...mapActions('modal', ['showModal', 'hideModal']),
      ...mapActions('alert', ['showToast']),

      async fetchTeachers(forcePage) {
        this.loading = true;
        const { page, itemsPerPage } = this.pagination;
        return teachersService.index({
          page: page || forcePage || 1,
          itemsPerPage,
          filters: this.requestFilters,
        })
          .then(response => {
            this.items = response.data.data;
            this.totalItems = response.data.meta.total;
            this.pagination = this.getPagination(
              response.data.meta,
              { oldPagination: this.pagination, forcePage },
            );
          })
          .catch(error => {
            this.handleError(error, this.errors);
          })
          .finally(() => {
            this.loading = false;
          });
      },
    },
    async created() {
      await this.fetchTeachers(this.pagination.page);
    },
    watch: {
      filters: {
        deep: true,
        handler() {
          this.fetchTeachers(1);
        },
      },
      schoolSelected: {
        immediate: true,
        handler(val) {
          this.$emit('input', val);
        },
      },
      'pagination.sortBy': {
        handler(oldVal, newVal) {
          if (newVal !== oldVal) {
            this.fetchTeachers(1);
          }
        },
      },

    },
  };
</script>
